globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { openJpKeys } from '@restworld/utils-common';
import { EmployerCard, EmployerCardHeader, EmployerCardFooter, EmployerCardInfo } from './employer-card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EmployerJobListingCard = /*#__PURE__*/memo(function EmployerJobListingCard(_ref) {
  var status = _ref.status,
      staffRequested = _ref.staffRequested,
      labels = _ref.labels,
      occupationLabel = _ref.occupationLabel,
      jobTitle = _ref.jobTitle,
      restaurant = _ref.restaurant,
      href = _ref.href,
      candidates = _ref.candidates,
      domainInterestKey = _ref.domainInterestKey,
      onClick = _ref.onClick;

  var _useTranslation = useTranslation('job-positions-page'),
      t = _useTranslation.t;

  var isOpen = openJpKeys.includes((status === null || status === void 0 ? void 0 : status.key) || '');
  var isDraftState = (status === null || status === void 0 ? void 0 : status.key) === 'jp_approval';
  var badgeVariant = isDraftState ? 'warning' : isOpen ? 'success' : 'disabled';
  var bagdeText = isDraftState ? t('draft') : isOpen ? t('open') : t('closed');
  var labelVariant = isOpen ? 'info' : 'disabled';
  var currentLabels = useMemo(function () {
    return labels ? [{
      text: "".concat(labels.visits || 0, " ").concat(t('visits')),
      variant: labelVariant
    }, {
      text: "".concat(labels.candidates || 0, " ").concat(t('candidates')),
      variant: labelVariant
    }, {
      text: "".concat(labels.qualified || 0, " ").concat(t('qualified')),
      variant: labelVariant
    }] : [];
  }, [labelVariant, labels, t]);
  var info = useMemo(function () {
    return {
      address: restaurant.address,
      businessName: restaurant.name,
      occupation: occupationLabel,
      openPositions: staffRequested,
      domainInterestKey: domainInterestKey
    };
  }, [domainInterestKey, occupationLabel, restaurant.address, restaurant.name, staffRequested]);
  var notification = useMemo(function () {
    return {
      candidateCount: candidates === null || candidates === void 0 ? void 0 : candidates.count,
      message: candidates === null || candidates === void 0 ? void 0 : candidates.message,
      candidates: candidates === null || candidates === void 0 ? void 0 : candidates.candidates,
      isAllSpontaneous: candidates === null || candidates === void 0 ? void 0 : candidates.isAllSpontaneous
    };
  }, [candidates === null || candidates === void 0 ? void 0 : candidates.candidates, candidates === null || candidates === void 0 ? void 0 : candidates.count, candidates === null || candidates === void 0 ? void 0 : candidates.isAllSpontaneous, candidates === null || candidates === void 0 ? void 0 : candidates.message]);
  return /*#__PURE__*/_jsxs(EmployerCard, {
    href: href,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(EmployerCardHeader, {
      logo: restaurant.logo,
      title: jobTitle,
      badge: {
        text: bagdeText,
        variant: badgeVariant
      }
    }), /*#__PURE__*/_jsx(EmployerCardInfo, {
      info: info
    }), /*#__PURE__*/_jsx(EmployerCardFooter, {
      labels: currentLabels,
      notification: notification
    })]
  });
});
export default /*#__PURE__*/memo(EmployerJobListingCard);